export default "__VITE_ASSET__D8aCsdEv__"